import React from "react";
import { FlaskConical } from "lucide-react";

/** Persistent label so the mock is never mistaken for a working product. */
function DemoDataBanner() {
  return (
    <span className="inline-flex items-center gap-1.5 rounded-full border border-amber-300 bg-amber-50 px-3 py-1 text-xs font-medium text-amber-800">
      <FlaskConical className="h-3.5 w-3.5" />
      Demo data — synthetic calls, actions are not saved
    </span>
  );
}

export default DemoDataBanner;
